import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { FAQS } from '../mock/mock';

const FAQ = () => {
  return (
    <section id="faqs" className="py-20 lg:py-24 bg-gradient-to-b from-white to-purple-50/40">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-purple-200 soft-shadow">
            <HelpCircle className="w-3.5 h-3.5 text-[#5F259F]" />
            <span className="text-[11px] font-bold tracking-wider text-[#5F259F] uppercase">FAQs</span>
          </div>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight">
            Frequently asked <span className="gradient-text">questions</span>
          </h2>
          <p className="mt-4 text-slate-600">Everything you need to know before getting started with HimalayanPOS.</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-purple-100 px-5 soft-shadow overflow-hidden">
                <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline py-4 hover:text-[#5F259F]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-[14px] leading-relaxed pb-4">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
